const RegistrationForm = () => (
  <div style={{ padding: "4rem", textAlign: "center" }}>
    <h2>Register for DolaGi Physical Event</h2>
    <p>Form will be available soon.</p>
  </div>
);
export default RegistrationForm;

